import { all } from 'redux-saga/effects';
import projectListSaga from '../../../../pages/project-management/project-list/data-access/+state/project-list.saga';
import createProjectSaga from '../../../../pages/project-management/create-project/data-access/+state/project-create.saga';

function* rootSaga() {
  yield all([projectListSaga(), createProjectSaga()]);
}
export default rootSaga;
